import { createContext } from 'react';
export var InstantSearchRSCContext = /*#__PURE__*/createContext(null);